<script setup>
import Toast from 'primevue/toast';
import ConfirmDialog from 'primevue/confirmdialog';
</script>

<template>
  <div>
    <Toast />
    <ConfirmDialog />
    <RouterView />
  </div>
</template>
